<div class="flex flex-col h-full">
    <!-- Header -->
    <div class="flex flex-0 items-center justify-between h-16 pr-3 sm:pr-5 pl-6 sm:pl-8 bg-primary text-on-primary">
        <span class="text-lg font-medium">{{ "workdayEventListMap.title" | transloco }}</span>
        <button mat-icon-button (click)="closeDialog()" [tabIndex]="-1">
            <mat-icon class="text-current" svgIcon="heroicons_outline:x"></mat-icon>
        </button>
    </div>
    <div class="h-full w-full p-4">
        <app-workday-geoposition-map [geopositionSummaryList]="data.geopositionSummaryList" [referenceGeopositionSummaryList] ="data.referenceGeopositionSummaryList" [initialMapCenterPosition]="data.initialMapCenterPosition"></app-workday-geoposition-map>
    </div>
</div>